import React from "react";

function Footer() {
  return (
    // <footer className="bg-gray-200 text-center text-xs p-3 absolute bottom-0">
    <footer className="bg-gray-700 text-yellow-400 text-center text-xs py-4 mt-10 w-full">
      v1.2.1 (9/10/2025) a Tatertech.net Hustle
    </footer>
  );
}

export default Footer;
